import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import useTiempoRecoleccionTransporte from "../../../hooks/administrador/recoleccion/useTiempoRecoleccionTransporte";
import '../../../styles/administrador.css';

const TiempoRecoleccionTransporte = ({ 
  year, 
  mes, 
  token, 
  idAdministrador,
  provinciaSeleccionada,
  ciudadSeleccionada 
}) => {
  const chartRef = useRef(null);
  
   
  const { data, loading, error } = useTiempoRecoleccionTransporte(
    year, 
    mes, 
    token, 
    idAdministrador,
    provinciaSeleccionada,
    ciudadSeleccionada
  );

  useEffect(() => {
    if (loading || error || !chartRef.current) return;
    
    if (!Array.isArray(data) || data.length === 0) {
      if (chartRef.current) {
        chartRef.current.innerHTML = "<p style='text-align: center; color: black;'>No hay datos disponibles</p>";
      }
      return;
    }

    const chartDom = chartRef.current;
    let myChart = echarts.getInstanceByDom(chartDom);
    if (myChart) myChart.dispose();
    myChart = echarts.init(chartDom);
    
    const categorias = [...new Set(data.map(item => item.Transportista))];
    const boxplotData = categorias.map(categoria => {
        const tiempos = data
          .filter(item => item.Transportista === categoria)
          .map(item => parseFloat(item.tiempo));
        
        if (tiempos.length === 0) return [0, 0, 0, 0, 0];
        
        tiempos.sort((a, b) => a - b);
        const min = tiempos[0];
        const max = tiempos[tiempos.length - 1];
        const q1 = tiempos[Math.floor(tiempos.length / 4)] || min;
        const median = tiempos[Math.floor(tiempos.length / 2)] || min;
        const q3 = tiempos[Math.floor(tiempos.length * 3 / 4)] || max;
        return [min, q1, median, q3, max];
    });

    const outliers = data.outliers || [];

     
    let titulo = 'Tiempo promedio de recolección';
    let subtitulo = 'SEGMENTADO POR GESTOR DE TRANSPORTE';
    
    if (provinciaSeleccionada) {
      const provinciaName = data[0]?.provincia_nombre || 'provincia seleccionada';
      if (ciudadSeleccionada) {
        const ciudadName = data[0]?.ciudad_nombre || 'ciudad seleccionada';
        subtitulo = `EN ${ciudadName.toUpperCase()}, ${provinciaName.toUpperCase()}`;
      } else {
        subtitulo = `EN ${provinciaName.toUpperCase()}`;
      }
    }

    let series = [{
        name: 'Tiempo de Recolección',
        type: 'boxplot',
        datasetIndex: 0,
        itemStyle: {
            color: '#B5CC18',
            borderColor: '#fff',
            borderWidth: 1.5
        },
        emphasis: {
            itemStyle: {
                borderColor: '#fff',
                borderWidth: 2,
                shadowBlur: 5,
                shadowColor: 'rgba(0, 0, 0, 0.3)'
            }
        },
        data: boxplotData
    }];

    if (outliers && outliers.length > 0) {
        series.push({
            name: 'Valores atípicos',
            type: 'scatter',
            datasetIndex: 0,
            data: outliers,
            itemStyle: {
                color: '#ee6666'
            }
        });
    }

    const option = {
        title: {
            text: titulo,
            left: 'center',
            subtext: subtitulo,
            subtextStyle: {
                fontSize: '12px',
                fontWeight: 'bold'
            },
        },
        tooltip: {
            trigger: 'item',
            confine: true,
            axisPointer: {
                type: 'shadow'
            },
            formatter: function(params) {
                if (params.seriesName === 'Tiempo de Recolección') {
                    const nombreGestor = categorias[params.dataIndex];
                    const promedio = params.data[3].toFixed(1);
                    return `${nombreGestor}<br/><b>Promedio: ${promedio} días</b>`;
                }
                return '';
            }
        },
        grid: {
            left: '30%',
            right: '10%',
            bottom: '15%'
        },
        yAxis: {
            type: 'category',
            data: categorias,
            boundaryGap: true,
            nameGap: 30,
            splitArea: {
                show: false
            },
            axisLabel: {
                formatter: function(value) {
                    return value.length > 10 ? value.substring(0, 10) + '...' : value;
                },
                rotate: 0,
                interval: 0,
                fontSize: 12,
                fontWeight: 'bold',
            },
            splitLine: {
                show: false
            }
        },
        xAxis: {
            type: 'value',
            name: 'Días',
            max: 14,
            splitArea: {
                show: true
            }
        },
        series: series.map(serie => ({
            ...serie,
            itemStyle: {
                color: '#B5CC18',
                borderColor: '#000',
                borderWidth: 1.5
            },
            emphasis: {
                itemStyle: {
                    borderColor: '#000',
                    borderWidth: 2,
                    shadowBlur: 5,
                    shadowColor: 'rgba(0, 0, 0, 0.3)'
                }
            }
        }))
    };

    myChart.setOption(option);

    const updateChart = () => {
      myChart.resize();
    };
    
    window.addEventListener('resize', updateChart);
    
    return () => {
      window.removeEventListener('resize', updateChart);
      if (myChart && !myChart.isDisposed()) {
        myChart.dispose();
      }
    };
  }, [data, loading, error, provinciaSeleccionada, ciudadSeleccionada]);

  if (loading) {
    return <div className="grafica loading">Cargando tiempos de recolección...</div>;
  }

  if (error) {
    return <div className="grafica error">Error al cargar los datos</div>;
  }

  return <div className="grafica" ref={chartRef}></div>;
};

export default TiempoRecoleccionTransporte;